import { render } from "./PhoneAuth.vue?vue&type=template&id=712b0721"
import script from "./PhoneAuth.vue?vue&type=script&lang=js"
export * from "./PhoneAuth.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__